import React from 'react';

import { StatusInfo } from 'features/order-tracker/shared-components';
import { AQA_ELEMENTS_MARKER_LIST } from 'features/order-tracker/utils/aqaElementsIDList';
import { ORDER_STATUSES } from 'features/order-tracker/utils/entries';

import styles from './style.module.scss';

export const OrderStatus: React.FC<components.OrderStatusProps> = ({ orderStatus }) => (
  <div className={styles.statusContainer}>
    <h2 className={styles.statusText}>Order status:</h2>
    <StatusInfo
      status={ORDER_STATUSES[orderStatus]}
      aqaId={AQA_ELEMENTS_MARKER_LIST.summaryPage.orderSummary.orderStatus}
    />
  </div>
);
